<template>
    <section class="reports-section user-report-section">
        <div class="rs-back" v-if="!showVideos">
            <a href="#" @click="backFromGraph()"><img src="@/module_dashboard/assets/images/rs-back.svg" alt="back" />
                Back</a>
        </div>
        <div class="rs-title" v-if="showVideos">
            <h2>{{ name }} Report</h2>
        </div>
        <div class="rs-title" v-if="!showVideos">
            <h2>{{ name }} Report - Generated Report</h2>
        </div>
        <div class="user-report-inner">
            <div class="user-report-serch">
                <div class="ur-userimag">
                    <img src="@/module_dashboard/assets/images/ur-user.svg" alt="user" />
                </div>
                <div class="ur-search-bar">
                        <div class="ur-search-form">
                            <label>NAME</label>
                            <div class="ur-search-input">
                                <input type="text" placeholder="" class="form-control" v-model="searchValue"
                                    @keyup="searchUser()" />
                                <div class="ur-input-icon">
                                    <img src="@/module_dashboard/assets/images/ur-search.svg" alt="search"
                                        @click="searchUser()" />
                                </div>
                                <div class="searchdropdown"
                                    v-if="showSearchDropdown && searchResults && searchResults.length > 0">
                                    <ul>
                                        <li class="cursor" v-for="searchResult of searchResults"
                                            @click="searchId(searchResult.id)">
                                            {{ searchResult.name.includes(null) ? searchResult.email : searchResult.name }}
                                            ({{ searchResult.team_name }})</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                </div>
                <div class="nsu-bottom pl-4 ml-auto" v-if="!showVideos">
                    <button class="ur-green-btn" @click="generatePDF()">EXPORT REPORT</button>
                </div>
            </div>
            <div class="user-serch-fillter">
                <ul>
                    <li class="user-card-item" v-if="(!corporateConfig.hideProgram && reportsData && reportsData.programs) || !corporateConfig.hideChallenge">
                        <div class="user-fillter-card">
                            <div class="user-fillter-info" v-if="!corporateConfig.hideProgram && reportsData && reportsData.programs">
                                <p class="user-fillter-title">PROGRAMS COMPLETED</p>
                                <span v-if="userSearchResult && reportsData && reportsData.programs">{{ reportsData.programs.completed }}/{{
                                    reportsData.programs.total }}</span>
                                <span v-else>0/0</span>
                            </div>
                            <div class="user-fillter-info" v-if="!corporateConfig.hideChallenge">
                                <p class="user-fillter-title">CHALLENGES COMPLETED</p>
                                <span v-if="userSearchResult && reportsData && reportsData.challenges">{{ reportsData.challenges.completed }}/{{
                                    reportsData.challenges.total }}</span>
                                <span v-else>0/0</span>
                            </div>
                        </div>
                    </li>
                    <li class="user-card-item">
                        <div class="user-fillter-card">
                            <div class="user-fillter-info">
                                <p class="user-fillter-title">AVERAGE ACCURACY</p>
                                <span v-if="userSearchResult && reportsData && reportsData.averageAccuracy">{{ reportsData.averageAccuracy
                                }}</span>
                                <span v-else>0%</span>
                            </div>
                            <!-- <div class="user-fillter-select">
                                <select class="form-select">
                                    <option selected>Average</option>
                                    <option value="1">One</option>
                                    <option value="2">Two</option>
                                    <option value="3">Three</option>
                                </select>
                            </div> -->
                        </div>
                    </li>
                    <li class="user-card-item">
                        <div class="user-fillter-card">
                            <div class="user-fillter-info">
                                <p class="user-fillter-title">WORKOUT DURATION</p>
                                <span v-if="userSearchResult && workoutDurationsVal">{{ workoutDurationsVal }}</span>
                                <span v-else> 0 mins</span>
                            </div>
                            <div class="user-fillter-select">
                                <select class="form-select" v-model="selectedOptionAverage" @change="handleChangeAverage">
                                    <option selected value="average">Average</option>
                                    <option value="total">Total</option>
                                </select>
                            </div>
                        </div>
                    </li>
                    <li class="user-card-item">
                        <div class="user-fillter-card">
                            <div class="user-fillter-info">
                                <p class="user-fillter-title">EFFECTIVE WORKOUT DURATION</p>
                                <span v-if="userSearchResult && effectiveWorkoutDurationsVal">{{ effectiveWorkoutDurationsVal }}</span>
                                <span v-else> 0 mins</span>
                            </div>
                            <div class="user-fillter-select">
                                <select class="form-select" v-model="selectedOptionEffectiveWorkout"
                                    @change="handleChangeEffectiveWorkout">
                                    <option selected value="average">Average</option>
                                    <option value="total">Total</option>
                                </select>
                            </div>
                        </div>
                    </li>
                    <li v-if="!disableCalories">
                        <div class="user-fillter-card">
                            <div class="user-fillter-info">
                                <p class="user-fillter-title">CALORIES BURNT</p>
                                <span v-if="userSearchResult && caloriesBruntVal">{{ caloriesBruntVal }}</span>
                                <span v-else> 0 </span>
                            </div>
                            <div class="user-fillter-select">
                                <select class="form-select" v-model="selectedOptionCaloriesBrunt"
                                    @change="handleChangeCaloriesBrunt">
                                    <option selected value="average">Average</option>
                                    <option value="total">Total</option>
                                </select>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="user-reports-tab" v-if="showVideos">
                <div class="rs-title">
                    <h2>Generate Report</h2>
                </div>
                <div class="reports-tab-inner">
                    <div class="reports-tabs">
                        <ul class="select-workout-button">
                            <li>
                                <a href="#select-workout" class="active">Select Workout(s)</a>
                            </li>
                            <!-- <li>
                                <a href="#">Select Challenge(s)</a>
                            </li>
                            <li>
                                <a href="#">Select Program(s)</a>
                            </li> -->
                        </ul>
                    </div>
                    <div class="reports-tabs-content">
                        <div class="reports-content-inner" id="select-workout">
                            <div class="reports-date-input">
                                    <b-row class="reports-date-group align-items-center px-2">
                                        <b-col cols=12 md=auto class='reports-form-date'>
                                            <label>FROM</label>
                                            <div class="reports-date-input">
                                                <b-form-datepicker placeholder="Add Date" :date-format-options="dateFormatOption"
                                                    class="form-control notranslate" :id="'fromDate'" type="date" :min="minFromDate"
                                                    :max="maxFromDate" v-model="fromDate">
                                                </b-form-datepicker>
                                            </div>
                                        </b-col>
                                        <b-col cols=12 md=auto class='reports-to-date'>
                                            <label>TO</label>
                                            <div class="reports-date-input">
                                                <b-form-datepicker placeholder="Add Date" :date-format-options="dateFormatOption" :min="minToDate"
                                                    :max="maxToDate" class="form-control notranslate" :id="'toDate'" type="date"
                                                    v-model="toDate">
                                                </b-form-datepicker>
                                            </div>
                                        </b-col>
                                        <b-col cols=12 md=auto class='nsu-bottom' style="padding-left: 15px !important">
                                            <button class="ur-green-btn" @click="getVideosData()">Filter</button>
                                        </b-col>
                                    </b-row>
                                    <div class="reports-date-bottom">
                                        <ul>
                                            <li><a href="">WORKOUT</a></li>
                                            <li>
                                                <div class="form-check">
                                                    <input class="form-check-input" type="checkbox" value=""
                                                        v-model="isChecked" id="flexCheckDefault"
                                                        @click="selectAllCheckboxes" />
                                                    <label class="form-check-label" for="flexCheckDefault">
                                                        <span> Select All</span>
                                                    </label>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                            </div>
                            <div class="urtab-innercontent">
                                <div v-if="userSearchResult && reportsVideoData && reportsVideoData.rows">
                                    <div class="ur-video-list">
                                        <div class="row">
                                            <div class="col-lg-3 col-md-6 col-sm-6"
                                                v-for="(video, index) in reportsVideoData.rows" :key="index">
                                                <div class="ur-video-card">
                                                    <input type="checkbox" :id="video.Video.id" :name="video.Video.id"
                                                        :value="video.Video.id" v-model="checkboxValues"
                                                        class="ur-video-checkbox" />
                                                    <label :for="video.Video.id" class="w-100">
                                                        <div class="ur-video-card-inner">
                                                            <div class="ur-video-thumbnail">
                                                                <img :src=video.Video.thumbnail alt="video thumbnail" />
                                                                <div class="ur-video-timer">
                                                                    {{ videoDuration(video.Video.duration) }}
                                                                </div>
                                                            </div>
                                                            <div class="ur-video-description">
                                                                <div class="ur-video-title">
                                                                    <h2>
                                                                        {{ video.Video.title }}
                                                                    </h2>
                                                                </div>
                                                                <div class="ur-video-status">
                                                                    <!-- <ul>
                                                                    <li>Exercise</li>
                                                                    <li>Advanced</li>
                                                                </ul> -->
                                                                </div>
                                                                <div class="ur-video-tag">
                                                                    <!-- <ul>
                                                                    <li>Cardio</li>
                                                                    <li>Short length</li>
                                                                    <li>Full body workouts</li>
                                                                    <li>Basic workouts</li>
                                                                </ul> -->
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="loadMore"
                                        v-if="reportsVideoData && reportsVideoData.totalPages && page < reportsVideoData.totalPages">
                                        <a @click="loadMoreData()">Load More...</a>
                                    </div>
                                    <div v-if="warningMessage">
                                        <p style="color: red; text-align: center;">{{ warningMessage }}</p>
                                    </div>
                                    <div class="nsu-bottom">
                                        <b-button class="ur-green-btn" v-b-tooltip.hover
                                            :title="!allowGenerate ? 'Upgrade to Advance to Generate' : ''"
                                            :disabled="!allowGenerate" @click="generateReport()">
                                            <b-icon-lock-fill v-if="!allowGenerate" class="mr-2" /> GENERATE REPORT
                                        </b-button><br />
                                        <button class="ur-greay-btn" @click="clearFilter()">Clear Filters</button>
                                    </div>
                                </div>
                                <div v-else class="not-select-user">
                                    <div class="not-select-img">
                                        <img src="@/module_dashboard/assets/images/user-not-selected.svg" alt="" />
                                    </div>
                                    <div class="not-select-user-content">
                                        <h2>No {{name}} selected</h2>
                                        <p>Select a {{ name }} using the search box above.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="!showVideos && graphDisplayData && graphDisplayData.length > 0">

            <div v-for="(graphDisplay, index) of graphDisplayData" :key="index">
                <ReportUserCard :data="graphDisplay"/>
            </div>
        </div>
    </section>
</template>

<script>
import { userService } from "@/module_dashboard/api/users";
import BarChart from "@/module_user/components/BarChart";
import { createNamespacedHelpers } from "vuex";
import moment from 'moment';
import html2pdf from 'html2pdf.js';
import ReportUserCard from './ReportUserCard'

const {
    mapState: layoutState,
    mapMutations: layoutMutations,
    mapActions: layoutActions,
} = createNamespacedHelpers("dashboard/layout");
const {
  mapGetters: mapThemeGetters
} = createNamespacedHelpers("themes");

export default {
    data() {
        return {
            selectedOptionAverage: "average",
            selectedOptionEffectiveWorkout: "average",
            selectedOptionCaloriesBrunt: "average",
            workoutDurationsVal: "",
            effectiveWorkoutDurationsVal: "",
            caloriesBruntVal: "",
            dateFormatOption: { year: 'numeric', month: 'short', day: '2-digit' },
            searchValue: "",
            searchResults: [],
            showSearchDropdown: false,
            checkboxValues: [],
            fromDate: '',
            toDate: '',
            minFromDate: undefined,
            maxFromDate: undefined,
            minToDate: undefined,
            maxToDate: undefined,
            userSearchResult: "",
            page: 1,
            isChecked: false,
            optionsBar: {
                legend: false,
                title: {
                    display: false,
                    text: ""
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            fontColor: '#white',
                            showLabelBackdrop: false
                        },
                    }],
                },
            },
            graphDisplayData: null,
            showVideos: true,
            warningMessage: ""
        }
    },
    methods: {
        ...layoutActions(['loadReprotsData', 'loadReportsVideo', 'graphReprots']),
        printPage() {
            window.print();
        },
        backFromGraph() {
            this.showVideos = true;
        },
        handleChangeAverage() {
            if (this.reportsData && this.reportsData.workoutDuration && this.selectedOptionAverage) {
                this.workoutDurationsVal = this.reportsData.workoutDuration[this.selectedOptionAverage]
            }
        },
        handleChangeEffectiveWorkout() {
            if (this.reportsData && this.reportsData.effectiveWorkoutMin && this.selectedOptionEffectiveWorkout) {
                this.effectiveWorkoutDurationsVal = this.reportsData.effectiveWorkoutMin[this.selectedOptionEffectiveWorkout]
            }
        },
        handleChangeCaloriesBrunt() {
            if (this.reportsData && this.reportsData.caloriesBurnt && this.selectedOptionCaloriesBrunt) {
                this.caloriesBruntVal = this.reportsData.caloriesBurnt[this.selectedOptionCaloriesBrunt]
            }
        },
        searchUser() {
            this.warningMessage = '';
            this.searchResults = [];
            userService.findUserByEmail(this.searchValue)
                .then(foundUsers => {
                    this.showSearchDropdown = true;
                    this.searchResults = [...this.searchResults, ...foundUsers];
                    this.searchResults = this.searchResults.splice(0, 10)
                })
                .catch(error => {
                    console.log("error---", error);
                })
        },
        videoDuration: function (time) {
            // Hours, minutes and seconds
            const hrs = ~~(time / 3600);
            const mins = ~~((time % 3600) / 60);
            const secs = ~~time % 60;

            // Output like "01:01" or "04:03:59" or "123:03:59"
            let ret = "";
            if (hrs > 0) {
                ret += "" + (hrs > 9 ? hrs : "0" + hrs) + ":";
            }
            ret += "" + (mins > 9 ? mins : "0" + mins) + ":";
            ret += "" + (secs > 9 ? secs : "0" + secs);
            return ret;
        },
        async searchId(id) {
            this.warningMessage = '';
            this.showVideos = true;
            this.page = 1;
            this.userSearchResult = id;
            this.showSearchDropdown = false;
            this.checkboxValues = [];
            this.isChecked = false;
            await this.loadReprotsData(id);
            if (this.reportsData && this.reportsData.workoutDuration && this.selectedOptionAverage) {
                this.workoutDurationsVal = this.reportsData.workoutDuration[this.selectedOptionAverage]
            }
            if (this.reportsData && this.reportsData.effectiveWorkoutMin && this.selectedOptionEffectiveWorkout) {
                this.effectiveWorkoutDurationsVal = this.reportsData.effectiveWorkoutMin[this.selectedOptionEffectiveWorkout]
            }
            if (this.reportsData && this.reportsData.caloriesBurnt && this.selectedOptionCaloriesBrunt) {
                this.caloriesBruntVal = this.reportsData.caloriesBurnt[this.selectedOptionCaloriesBrunt]
            }
            if ((this.reportsData && this.reportsData.name) || (this.reportsData.email)) {
                this.searchValue = this.reportsData.name || this.reportsData.email;
            }

            let obj = {
                "userId": this.userSearchResult,
                "startDate": this.fromDate,
                "endDate": this.toDate,
                "page": 1,
                "pageSize": 10
            }

            await this.loadReportsVideo(obj);
        },
        async getVideosData() {
            this.warningMessage = '';
            this.checkboxValues = [];
            this.isChecked = false;
            this.page = 1;
            let obj = {
                "userId": this.userSearchResult,
                "startDate": this.fromDate,
                "endDate": this.toDate,
                "page": 1,
                "pageSize": 10
            }
            await this.loadReportsVideo(obj);
        },
        async clearFilter() {
            this.warningMessage = '';
            this.checkboxValues = [];
            this.fromDate = '';
            this.isChecked = false;
            this.toDate = '';
            this.page = 1;
            let obj = {
                "userId": this.userSearchResult,
                "page": 1,
                "pageSize": 10
            }
            await this.loadReportsVideo(obj);
        },
        async generateReport() {
            this.warningMessage = '';
            if (this.checkboxValues && this.checkboxValues.length > 0) {
                this.graphDisplayData = null;
                this.showVideos = false;
                let obj = {
                    "userId": this.userSearchResult,
                    "videoIds": this.checkboxValues,
                    "startDate": this.fromDate,
                    "endDate": this.toDate
                }
                await this.graphReprots(obj);
                let objOfArr = {};
                if (this.setReportsGraphDataState) {
                    for (const setReportsgraph of this.setReportsGraphDataState) {
                        let avgAccuracyArr = []; let workoutDateArr = []; let caloriesBurntArr = []; let workoutDurationArr = []; let colorDataArr = [];
                        let minFromDate, maxToDate
                        if (setReportsgraph && setReportsgraph.UserExerciseHistories) {
                            for (const UserExerciseHistorie of setReportsgraph.UserExerciseHistories) {
                                avgAccuracyArr.push(UserExerciseHistorie['avgAccuracyScore']);
                                workoutDateArr.push(moment(UserExerciseHistorie['workoutDate']).format('YYYY-MM-DD'));
                                caloriesBurntArr.push(UserExerciseHistorie['caloriesBurnt']);
                                workoutDurationArr.push(UserExerciseHistorie['workoutDuration']);
                                colorDataArr.push('#73bc44')
                                if(minFromDate == null){
                                    minFromDate = moment(UserExerciseHistorie['workoutDate'])
                                }else{
                                    minFromDate = moment.min(minFromDate, moment(UserExerciseHistorie['workoutDate']))
                                }
                                if(maxToDate == null){
                                    maxToDate= moment(UserExerciseHistorie['workoutDate'])
                                }else{
                                    maxToDate = moment.max(maxToDate, moment(UserExerciseHistorie['workoutDate']))
                                }
                            }
                            objOfArr[setReportsgraph.id] = {
                                avgAccuracyArr: avgAccuracyArr,
                                workoutDateArr: workoutDateArr,
                                caloriesBurntArr: caloriesBurntArr,
                                workoutDurationArr: workoutDurationArr,
                                colorDataArr: colorDataArr,
                                thumbnail: setReportsgraph.thumbnail,
                                title: setReportsgraph.title,
                                minFromDate,
                                maxToDate
                            }
                        }
                    }
                }

                let barOfArray = [];
                let grpahCount = 1;
                for (let key in objOfArr) {
                    let objInsidegraph = {};
                    let objData = this.getChartData(
                        [],
                        objOfArr[key].workoutDateArr,
                        objOfArr[key].avgAccuracyArr,
                        objOfArr[key].colorDataArr
                    )
                    const obj3 = this.getChartData(
                        [],
                        objOfArr[key].workoutDateArr,
                        objOfArr[key].caloriesBurntArr,
                        objOfArr[key].colorDataArr
                    )
                    const obj2 = this.getChartData(
                        [],
                        objOfArr[key].workoutDateArr,
                        objOfArr[key].workoutDurationArr,
                        objOfArr[key].colorDataArr
                    )
                    objInsidegraph.thumbnail = objOfArr[key].thumbnail;
                    objInsidegraph.title = objOfArr[key].title;
                    objInsidegraph.firstGraph = objData;
                    objInsidegraph.secondGraph = obj2;
                    objInsidegraph.ThirdGraph = obj3;
                    objInsidegraph.graphId = grpahCount
                    objInsidegraph.minFromDate = objOfArr[key].minFromDate
                    objInsidegraph.maxToDate = objOfArr[key].maxToDate
                    barOfArray.push(objInsidegraph);
                    grpahCount = grpahCount + 1;
                }
                this.graphDisplayData = barOfArray
            } else {
                this.warningMessage = 'Please Select atleast one video to generate report'
            }
        },

        getChartData(chartLabel, labels, dataPoints, backgroundColor = []) {
            return {
                labels: labels,
                datasets: [
                    {
                        label: chartLabel,
                        data: dataPoints,
                        backgroundColor: backgroundColor,
                        tension: 0.4
                    },
                ]
            }
        },

        async loadMoreData() {
            this.warningMessage = '';
            this.page = this.page + 1;
            let obj = {
                "userId": this.userSearchResult,
                "startDate": this.fromDate,
                "endDate": this.toDate,
                "page": this.page,
                "pageSize": 10,
                "addState": true
            }
            await this.loadReportsVideo(obj);
        },
        selectAllCheckboxes() {
            this.warningMessage = '';
            if (this.isChecked) {
                this.checkboxValues = [];
            } else {
                this.checkboxValues = this.reportsVideoData.rows.map(video => video.Video.id);
            }
        },
        onBarClicked(index) {
            this.$router.push(
                `/management/playback/${this.setReportsGraphDataState[index.graphId - 1].UserExerciseHistories[0].sessionId}`
            )
        },
        async generatePDF() {
            try {

                const content = this.$el;
                const options = {
                    margin: [10, 10],
                    filename: 'my_vue_app.pdf',
                    image: { type: 'jpeg', quality: 0.98 },
                    html2canvas: { scale: 2 },
                    jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
                };

                html2pdf().from(content).set(options).save();

            } catch (error) {
                // Handle the error if the image fails to load
                console.error('Image loading error:', error);
            }
        },
    },
    components: {
        BarChart,ReportUserCard
    },
    watch: {
        fromDate: function (val) {
            this.minToDate = new Date(val);
        },
        toDate: function (val) {
            this.maxFromDate = new Date(val);
        },
    },
    computed: {
        ...layoutState([
            "reportsData", "reportsVideoData", "setReportsGraphDataState"
        ]),
        ...mapThemeGetters(["theme", "pages"]),
        name() {
          return this.theme[this.pages.SMB_USERS].name;
        },
        allowGenerate() {
            return this.$store.state.userInfo?.corporate?.subscription?.show_analytics;
        },
        disableCalories(){
            return this.$store?.state?.userInfo?.corporate?.config?.disableCalories ?? false
        },
        corporateConfig() {
          return this.$store.state.userInfo?.corporate?.config || {};
        }
    },
    async mounted() {
        this.page = 1;
    },
}
</script>

<style lang="scss" scoped>
.reports-section {
    padding: 40px 30px;
    font-family: "Poppins", sans-serif;
}

.reports-section a,
.reports-section a:hover {
    text-decoration: none;
}

.rs-title {
    padding-bottom: 30px;
}

.rs-title h2 {
    color: #141513;
    font-size: 24px;
    font-family: "Poppins", sans-serif;
    font-weight: 700;
}

.user-report-serch {
    display: flex;
    align-items: center;
    padding-bottom: 30px;
}

.ur-userimag {
    width: 82px;
    height: 82px;
    border-radius: 100%;
    overflow: hidden;
}

.ur-userimag img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center center;
}

.ur-search-bar {
    flex: 1;
    max-width: 390px;
    padding-left: 36px;
}

.ur-search-form label {
    color: #969b92;
    font-size: 16px;
    line-height: 18px;
    padding-bottom: 5px;
    margin-bottom: 0;
    font-weight: 700;
}

.ur-search-input {
    position: relative;
}

.ur-search-input .form-control {
    padding: 14px 50px 14px 24px;
    height: auto;
    font-size: 16px;
    line-height: 1;
    border-radius: 5px;
    border: 2px solid black;
}

.ur-input-icon {
    position: absolute;
    top: 15px;
    right: 20px;
}

.ur-input-icon img {
    width: 28px;
}

.user-serch-fillter {
    padding-bottom: 40px;
}

.user-serch-fillter ul {
    padding-left: 30px;
    display: flex;
    flex-wrap: wrap;
}

.user-serch-fillter li {
    list-style: none;
    padding: 6px;
}

.user-serch-fillter li .user-fillter-card {
    border-radius: 6px;
    border: 2px solid #d0e0c8;
    padding: 15px 12px;
    min-width: 173px;
    max-width: 190px;
    height: 100%;
}

.user-fillter-card .user-fillter-info {
    padding-bottom: 5px;
}

.user-fillter-card .user-fillter-info p.user-fillter-title {
    padding-bottom: 3px;
    margin-bottom: 0;
    color: #73bc44;
    font-size: 12px;
    font-weight: 700;
    line-height: 14px;
    width: 100%;
}

.user-fillter-card .user-fillter-info span {
    color: #141513;
    line-height: 16px;
    font-size: 16px;
    font-family: Poppins;
    font-weight: 700;
}

.user-fillter-select {
    padding-top: 12px;
}

.user-fillter-select .form-select {
    border-radius: 5px;
    border: 2px solid #969b92;
    background: #fff;
    width: 100%;
    padding-top: 5px;
    padding-bottom: 5px;
    padding-left: 12px;
    border-radius: 5px;
    height: auto;
    border: 2px solid #969b92;
    background: #fff;
    line-height: 1;
    font-size: 12px;
}

.user-reports-tab {
    padding-left: 30px;
}

.reports-tabs ul {
    display: flex;
    flex-wrap: wrap;
    list-style: none;
    padding: 0;
    margin: 0;
}

.reports-tabs ul li {
    padding-right: 8px;
    padding-bottom: 5px;
}

.reports-tabs ul li a {
    height: 100%;
    background: #eeeded;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
    padding: 8px 10px;
    color: #000;
    font-size: 16px;
    line-height: 18px;
    text-decoration: none;
    display: inline-block;
}

.reports-tabs ul li a:hover,
.reports-tabs ul li a.active {
    background: #8dc63f;
    color: #fff;
}

.reports-tabs-content {
    background: #fff;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
    padding: 15px 10px;
}

.reports-date-input .reports-date-group {
    display: flex;
    flex-wrap: wrap;
}

.reports-date-group label {
    color: #73bc44;
    font-size: 12px;
    font-family: Poppins;
    font-weight: 700;
    margin: 0;
    padding-bottom: 4px;
}

.reports-form-date {
    margin-right: 17px;
}

.reports-date-input {
    position: relative;
}

.reports-date-input img {
    position: absolute;
    top: 7px;
    left: 8px;
}

.reports-date-input .form-control {
    border-radius: 5px;
    border: 2px solid #969b92;
    background: #fff;
    padding: 8px 12px;
    font-size: 12px;
    font-family: Poppins;
    font-weight: 500;
    line-height: 1;
    color: #73bc44;
    padding-left: 30px;
}

.reports-date-input .form-control::placeholder {
    color: #73bc44;
}

.reports-form-date,
.reports-to-date {
    margin-bottom: 20px;
}

.reports-date-bottom ul {
    padding-left: 0;
    display: flex;
    align-items: center;
}

.reports-date-bottom li {
    list-style: none;
    margin-right: 16px;
}

.reports-date-bottom li a {
    color: #73bc44;
    font-size: 12px;
    font-family: Poppins;
    font-weight: 700;
    line-height: 16px;
}

.reports-date-bottom li .form-check-label {
    color: #969b92;
    font-size: 12px;
    font-family: Poppins;
    font-weight: 500;
}

.reports-date-bottom li .form-check-input {
    width: 17px;
    height: 17px;
    border-color: #73bc44;
}

.reports-date-bottom li .form-check-label span {
    padding-left: 10px;
}

.urtab-innercontent {
    padding: 20px 0;
}

.not-select-user {
    text-align: center;
    padding: 30px 0;
}

.user-report-section img {
    max-width: 100%;
}

.not-select-img {
    max-width: 180px;
    margin: 0 auto;
    padding-bottom: 30px;
}

.not-select-user-content h2 {
    color: #141513;
    font-size: 24px;
    font-family: Poppins;
    font-weight: 700;
    margin-bottom: 0;
    padding-bottom: 16px;
}

.not-select-user-content p {
    color: #969b92;
    font-size: 16px;
    font-family: Poppins;
    font-weight: 500;
}

.nsu-bottom {
    padding-top: 18px;
}

.nsu-bottom .ur-green-btn {
    border-radius: 25px;
    background: #8dc63f;
    box-shadow: 0px 16px 49px 0px rgba(20, 21, 19, 0.15);
    padding: 12px 24px;
    line-height: 1;
    color: #fff;
    text-align: center;
    font-size: 18px;
    font-family: Poppins;
    font-weight: 700;
    width: 100%;
    max-width: 333px;
    border: 0px;
    transition: all 0.5s;
    margin-bottom: 15px;
    display: inline-block;
}

.nsu-bottom .ur-green-btn:hover,
.ur-greay-btn:hover {
    background: rgba(20, 21, 19);
}

.ur-greay-btn {
    border-radius: 25px;
    background: #969b92;
    box-shadow: 0px 16px 49px 0px rgba(20, 21, 19, 0.15);
    line-height: 1;
    padding: 10px 24px;
    color: #fff;
    text-align: center;
    font-size: 14px;
    font-family: Poppins;
    font-weight: 700;
    border: none;
    transition: all 0.5s;
}

/*******/
.ur-video-checkbox {
    display: none;
}

.ur-video-thumbnail {
    position: relative;
    height: 0;
    width: 100%;
    padding-bottom: 58%;
    border-radius: 15px;
    overflow: hidden;
}

.ur-video-thumbnail img,
.ur-video-thumbnail video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center center;
    position: absolute;
    top: 0;
    left: 0;
}

.ur-video-title h2 {
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
}

.ur-video-description {
    padding: 10px;
}

.ur-video-timer {
    position: absolute;
    bottom: 10px;
    right: 10px;
    background-color: #000000c2;
    color: #fff;
    padding: 3px 10px;
    font-size: 14px;
}

.ur-video-status ul {
    padding: 0;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}

.ur-video-status ul li {
    list-style: none;
    font-size: 12px;
    line-height: 16px;
    color: #969B92;
    padding: 0 10px;
    position: relative;
}

.ur-video-status ul li::after {
    content: "";
    width: 3px;
    height: 3px;
    background-color: #969B92;
    border-radius: 100%;
    position: absolute;
    top: 7px;
    left: 0;
}

.ur-video-status ul li:first-child {
    font-weight: 600;
    padding-left: 0;
}

.ur-video-status ul li:first-child::after {
    display: none;
}

.ur-video-tag ul {
    padding-left: 0;
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 0;
}

.ur-video-tag ul li {
    list-style: none;
    color: #73BC44;
    border: 1px solid #73BC44;
    border-radius: 10px;
    font-size: 12px;
    padding: 2px 5px;
    margin-right: 5px;
    margin-bottom: 5px;
}

.ur-video-card-inner {
    border: 5px solid transparent;
    padding: 5px;
}

.ur-video-checkbox:checked~label .ur-video-card-inner {
    border: 5px solid #8dc63f;
}

.ur-video-card {
    padding-bottom: 15px;
}

.nsu-bottom {
    text-align: center;
}

.searchdropdown {
    position: absolute;
    background: white;
    top: 100%;
    left: 0;
    padding: 15px;
    width: 100%;
    border-radius: 10px;
}

.searchdropdown ul li {
    list-style: none;
    padding: 3px;
}

.loadMore {
    text-align: center;
    color: #73BC44;
    font-size: 18px;
    padding-bottom: 40px;
    cursor: pointer;
}

.cursor {
    cursor: pointer;
}


.rs-back {
    padding-top: 10px;
    padding-bottom: 30px;

}

.rs-back a {
    color: #141513;
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.rs-back img {
    padding-right: 8px;
}

@media screen and (max-width: 768px) {
  .user-card-item{
   width: 100%;
   .user-fillter-card{
    max-width: none !important;
   }
  }

  .rs-title{
    text-align: center;
  }
  .user-serch-fillter ul{
    padding-left: 0;
  }

  .user-serch-fillter li{
    padding-left: 0;
    padding-right: 0;
  }

  .user-report-serch{
    flex-direction: column;
  }

  .ur-search-bar{
    max-width: none !important;
    padding-left: 0;
  }

  .user-reports-tab{
    padding-left: 0 !important;
  }

  .select-workout-button{
    display: flex;
    justify-content: center;
  }

  .nsu-bottom{
    padding-left: 0 !important;
    margin-left: unset !important;
  }
  }
</style>
